import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme } from '@mui/material/styles';
import { primarycolor } from '../Utils/colors';
import { setLoggedIn, setUser } from '../../store/user';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@mui/material';
import { Erroralert, Successalert } from '../Components/popups';
import fetch from '../Utils/fetch';



let color = "white";
let type = "spokes";

function Copyright({ sx, fullName }) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" sx={sx}>
      {'Copyright © '}
      <Link color="inherit" to="/nav/terms">
        {fullName}   All Rights Reserved.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();

export default function SignIn({ onsuccesslogin, ondismiss }) {
  const dispatch = useDispatch();
  const webSettings = useSelector((state) => state.webSettings.data);
  const fullName = webSettings.FULL_NAME;
  const firstname = fullName?.split(' ')[0];

  const [checked, setChecked] = React.useState(true);
  const [progress, setprogress] = useState(false);
  const [error, seterror] = useState('');
  const [success, setsuccess] = useState('');


  const [showresetpass, setshowresetpass] = useState(false);
  const [showlogin, setshowlogin] = useState(true);


  const handleSubmit = (event) => {
    seterror(null)
    setprogress(true)
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get('email')
    const password = data.get('password')
    if (!email || !password) {
      seterror("fill all fields")
      setprogress(false)
    } else {
      seterror(null)
      fetch.get('getLogin', {
        username: email,
        password: password
      }).then(response => {
        if (!response.error) {
          let data = response.list[0];
          if (data) {
            setprogress(false)
            if (data.PASSWORD === '<PASSWORD-ACCEPTED>' || data.PASSWORD === '<PASSWORD-NOT-SET>') {
              setsuccess('Login successful!')
              dispatch(setUser(data));
              dispatch(setLoggedIn(true));
              setTimeout(() => {
                onsuccesslogin()
              }, 3000);

            } else {
              seterror("Wrong Password");
            }
          } else {
            seterror("Invalid Credentials");
          }
        } else {
          setprogress(false)
          seterror(response.data.message)
        }
        // 
      }).catch(error => {
        setprogress(false)
        seterror("Sorry an error occurred,try again later");
      });
    }
  };




  const handleChange = (event) => {
    setChecked(event.target.checked);
  };




  return (
    <Modal
      open={true}
      onClose={() => ondismiss()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Container component="main" maxWidth="xs" style={{ backgroundColor: "white", borderRadius: 20 }}>
        <CssBaseline />
        {error?.length > 0 && <Erroralert onClose={() => seterror()} message={error} />}
        {success?.length > 0 && <Successalert onClose={() => setsuccess()} message={success} />}
        {showlogin &&
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: primarycolor }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <FormControlLabel
                control={<Checkbox onChange={handleChange} value="remember" color="primary" />}
                label="Remember me"
              />
              {/* {error && <div style={{ color: "red", fontSize: 10 }}>{error}</div>} */}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                {progress ? <ReactLoading type={type} color={color} height={25} width={20} /> : "Sign In"}
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link to="" style={{ color: primarycolor, fontSize: 13 }} variant="body2">
                    Don't have an account?
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>}
        <Copyright sx={{ mt: 8, mb: 4 }} fullName={fullName} />
      </Container>
    </Modal>

  );
}